"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDeletedSourceInProgram = updateDeletedSourceInProgram;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _logProgramChange = require("@studio/logger/datadog/logProgramChange");
var _attachAudioPresenterSources = require("./attachAudioPresenterSources");
var _utils = require("../utils");
var _sceneBuilder = require("../sceneBuilder");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param {string} sourceId
 * @param {object} deleteParams data to help understand subsequent action to perform
 * @param setProgram
 */
function updateDeletedSourceInProgram(sourceId) {
  var deleteParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var setProgram = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState) {
    var _getState = getState(),
      program = _getState.program,
      backgrounds = _getState.backgrounds,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      brandingSettings = _getState.brandingSettings;
    if (!deleteParams.isBackgroundSource) {
      // layer._id within the condition handles the case where source
      // is an overlay or a banner then the layer._id is the id of the overlay or banner
      var sourceInProgram = program.layers.find(function (layer) {
        var _layer$source, _layer$source2, _deleteParams$replace;
        return (layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source._id) === sourceId || (layer === null || layer === void 0 ? void 0 : layer._id) === sourceId || (layer === null || layer === void 0 || (_layer$source2 = layer.source) === null || _layer$source2 === void 0 ? void 0 : _layer$source2._id) === (deleteParams === null || deleteParams === void 0 || (_deleteParams$replace = deleteParams.replacementSource) === null || _deleteParams$replace === void 0 ? void 0 : _deleteParams$replace._id);
      });
      if (sourceInProgram) {
        var updatedLayers = program.layers.filter(function (layer) {
          var _layer$source3;
          return (layer === null || layer === void 0 || (_layer$source3 = layer.source) === null || _layer$source3 === void 0 ? void 0 : _layer$source3._id) !== sourceId && (layer === null || layer === void 0 ? void 0 : layer._id) !== sourceId;
        });
        var sources = updatedLayers.map(function (layer) {
          return layer.source;
        });
        var layout = {
          id: program.layout,
          title: program.title,
          thumbnail: program.thumbnail
        };
        var isOverlayOrBanner = program.layers.find(function (layer) {
          return layer._id === sourceId;
        });
        var layers = updatedLayers;
        // Should only rebuild layer with deleted/replaced source is not
        // an overlay or a banner source
        if (!isOverlayOrBanner) {
          var sceneLayers = ['SCENE_LAYER'].concat((0, _toConsumableArray2["default"])((0, _utils.getSceneLayerSources)(updatedLayers)));
          var withAudioPresenterSources = (0, _attachAudioPresenterSources.attachAudioPresenterSources)(sources, attendeeMuteStatus);
          var builtScene = (0, _sceneBuilder.sceneBuilder)(layout, withAudioPresenterSources, sceneLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);
          layers = builtScene.layers;
        }
        var updatedProgram = _objectSpread(_objectSpread({}, program), {}, {
          layers: layers
        });
        dispatch(setProgram(updatedProgram));
        (0, _logProgramChange.logProgramChange)('updateDeletedSourceInProgram action - removing source (NOT layer source)');
      }
    } else {
      var backgroundInProgram = program.style.backgroundId === sourceId;
      if (backgroundInProgram) {
        var background = backgrounds.find(function (b) {
          var _b$source, _deleteParams$replace2;
          return (b === null || b === void 0 || (_b$source = b.source) === null || _b$source === void 0 ? void 0 : _b$source._id) === (deleteParams === null || deleteParams === void 0 || (_deleteParams$replace2 = deleteParams.replacementSource) === null || _deleteParams$replace2 === void 0 ? void 0 : _deleteParams$replace2._id);
        });
        var _updatedProgram = _objectSpread(_objectSpread({}, program), {}, {
          style: {
            backgroundColor: '#000000'
          }
        });
        if (background) {
          _updatedProgram = _objectSpread(_objectSpread({}, program), {}, {
            style: _objectSpread(_objectSpread({}, program.style), {}, {
              backgroundId: background._id,
              backgroundImage: "url(".concat(background.source.value.url, ")")
            })
          });
        }
        dispatch(setProgram(_updatedProgram));
        (0, _logProgramChange.logProgramChange)('updateDeletedSourceInProgram action - removing background');
      }
    }
  };
}